var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('style',{tag:"component",attrs:{"type":"text/css"}},[_vm._v(" :root { "),_vm._l((_vm.colors),function(color,colorName){return [_vm._v(" --"+_vm._s(colorName)+": "+_vm._s(color)+"; ")]}),_vm._v(" } "+_vm._s(_vm.ownStyle)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }